<template>
  <div id="modalDuplicateTemplate" class="modal-dialog myMoDi" v-if="showDialog">
    <div class="modalHeader">
      <span class="title">Duplicate Template</span>
      <span @click="closeModal" class="btn-close float-right"><i class="fas fa-times"></i></span>
    </div>

    <div class="modalBody">
      <div class="form-group">
        <label for="duplicateSource">Source Template:</label>
        <select id="duplicateSource" class="form-control form-control-sm" v-model="sourceTemplateName">
          <option v-for="(template, index) in $store.state.templates" :key="index">
            {{ template.name }}
          </option>
        </select>
      </div>

      <div class="form-group">
        <label for="newTemplateName">New Template Name</label>
        <input class="form-control form-control-sm" type="text" id="newTemplateName" v-model="newTemplateName">
      </div>
      <button class="btn btn-success" @click="duplicate">Duplicate</button>
      <button class="btn btn-danger" @click="closeModal">Cancel</button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'modal-duplicate-template',

  data () {
    return {
      showDialog: false,
      newTemplateName: '',
      sourceTemplateName: 'global'
    }
  },

  mounted () {
    let that = this
    this.sourceTemplateName = this.$store.state.currentTemplateName
    this.$bus.on('showTemplateDuplicateDialog', function () {
      that.showDialog = true
    })
  },

  methods: {
    duplicate () {
      let templateData = JSON.parse(JSON.stringify(this.$store.state.templates[this.sourceTemplateName]))
      templateData['name'] = this.newTemplateName
      if (typeof templateData['pages'] === 'undefined') templateData['pages'] = {}
      delete templateData['_id']

      const apiUrl = this.$store.state.apiUrl
      this.axios.post(apiUrl + 'template/add', templateData).then(response => {
        if (response.data.success) {
          templateData['_id'] = response.data.id

          let questionnaireData = {}
          if (typeof this.$store.state.questionnaires[this.sourceTemplateName] !== 'undefined') {
            questionnaireData = JSON.parse(JSON.stringify(this.$store.state.questionnaires[this.sourceTemplateName]))
            delete questionnaireData['_id']
            questionnaireData['templateId'] = response.data.id
          }

          this.axios.post(apiUrl + 'questionnaire/add', questionnaireData).then(response => {
            if (response.data.success) {
              templateData['questionnaire_id'] = response.data.id
              this.$store.commit('addTemplate', {
                id: this.newTemplateName,
                data: templateData
              })

              this.$store.commit('addQuestionnaire', {
                index: templateData.name,
                data: {
                  '_id': response.data.id,
                  templateId: templateData['_id'],
                  data: {}
                }
              })

              this.$bus.emit('addNotification', {
                title: 'Template Created',
                body: 'The template was created successfully',
                type: 'success'
              })

              // Reactivity Hacks
              this.$store.commit('setShowAnnotationMenu', true)
              this.$store.commit('setDrawAnnotations', true)
              this.$store.commit('setShowBottomMenu', false)
              this.$store.commit('setShowAnnotationMenu', false)
              this.$store.commit('setDrawAnnotations', false)
              this.$store.commit('setShowBottomMenu', true)

              this.closeModal()
            } else {
              this.$bus.emit('addNotification', {
                title: 'Template Questionnaire Error',
                body: 'There was an error creating the template questionnaire. Please review the data and try again',
                type: 'error'
              })
            }
          })
        } else {
          this.$bus.emit('addNotification', {
            title: 'Template Error',
            body: 'There was an error creating the template. Please review the data and try again',
            type: 'error'
          })
        }
      })
      this.$store.commit('setLastSaved', Date.now())
    },

    closeModal () {
      this.showDialog = false
    }
  },

  beforeDestroy () {
    this.$bus.$off('showTemplateDuplicateDialog')
  }
}
</script>

<style lang="scss" scoped>
  .modal-dialog {
    user-select: none;
    position: fixed;
    top: 10%;
    left: 50%;
    margin-left: -25%;
    width: 50%;
    height: 258px;
    border: 1px solid black;
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
    background-color: #FFF;
    overflow: hidden;
    z-index: 1;

    .modalHeader {
      background-color: #2d5f8b;
      color: white;
      font-size: 18px;
      padding: 5px 10px 5px 10px;

      .btn-close {
        cursor: pointer;
        color: #FFF;
      }
    }

    .modalBody {
      padding: 10px;
    }
  }

  .myMoDi{
    pointer-events: auto;
    max-width: initial;
  }
</style>




// WEBPACK FOOTER //
// src/components/editor/modals/ModalDuplicateTemplate.vue